<script lang="ts" setup>
import { ChevronDown } from "@lucide/vue";
import type { Column, Table } from "@tanstack/vue-table";

const _props = defineProps<{
	item: Column<unknown>;
	table: Table<unknown>;
}>();

function titleCase(s: string) {
	return s
		.replace(/^[-_]*(.)/, (_, c) => c.toUpperCase()) // Initial char (after -/_)
		.replace(/[-_]+(.)/g, (_, c) => ` ${c.toUpperCase()}`); // First char after each -/_
}

const isCollapsibleOpen = ref(false);
</script>

<template>
	<template v-if="item.columns.length > 0">
		<Collapsible :key="item.id" v-slot="{ open: subcatOpen }" v-model:open="isCollapsibleOpen">
			<CollapsibleTrigger
				class="flex w-full items-center justify-between gap-1 p-2 text-left text-sm"
			>
				<div>
					<span>{{ item.columnDef.header ?? titleCase(item.id) }}</span>
					<Badge
						v-if="
							item.columns.length > 0 &&
							item.getLeafColumns().filter((c) => c.getIsVisible()).length
						"
						class="ml-2"
						variant="outline"
						>{{ item.getLeafColumns().filter((c) => c.getIsVisible()).length }}</Badge
					>
				</div>

				<ChevronDown
					class="size-4 shrink-0 grow-0"
					:class="subcatOpen ? 'rotate-180' : ''"
				></ChevronDown>
			</CollapsibleTrigger>

			<CollapsibleContent class="">
				<GeojsonMapToolbarItem
					v-for="subItem in item.columns"
					:key="subItem.id"
					:item="subItem"
					:table="table"
				/>
			</CollapsibleContent>
		</Collapsible>
	</template>
	<template v-else>
		<FeatureSelectionDialog :column="item as Column<unknown>" :table="table" />
	</template>
</template>
